export const TOOLTIP_INFO = 'TOOLTIP_INFO';
export const TOOLTIP_WARNING = 'TOOLTIP_WARNING';
export const TOOLTIP_ERROR = 'TOOLTIP_ERROR';

export const TOOLTIP_ICON_LOCK = 'fa-lock';
export const TOOLTIP_ICON_INFO = 'fa-info-circle';
export const TOOLTIP_ICON_CHECK = 'fa-check-circle';
export const TOOLTIP_ICON_EXCLAMATION = 'fa-exclamation-circle';

export const COLOR_RED = 'red';
export const COLOR_BLUE = 'blue';
export const COLOR_YELLOW = 'yellow';
export const COLOR_GREEN = 'green';
export const COLOR_PURPLE = 'purple';
export const COLOR_PINK = 'pink';
export const COLOR_ORANGE = 'orange';
export const COLOR_TURQUOISE = 'turquoise';
export const COLOR_PINK_LIGHT = 'pink-light';
export const COLOR_GREEN_LIGHT = 'green-light';
export const COLOR_TURQUOISE_DARK = 'turquoise-dark';
export const COLOR_BLUE_DARK = 'dark-blue';
export const COLOR_WHITE = 'white';

export const ICON_AANVRAAG = 'ICON_AANVRAAG';
export const ICON_PROJECT = 'ICON_PROJECT';
export const ICON_MINIMALEEISEN = 'ICON_MINIMALEEISEN';
export const ICON_FINANCIEEL = 'ICON_FINANCIEEL';
export const ICON_BOVENLOKALITEIT = 'ICON_BOVENLOKALITEIT';
export const ICON_BEOORDELINGSCRITERIA = 'ICON_BEOORDELINGSCRITERIA';
export const ICON_INDIENEN = 'ICON_INDIENEN';
export const ICON_FINANCIELEVERANTWOORDING = "ICON_FINANCIELEVERANTWOORDING";

export const FONT_ICON_EXCLAMATION = 'fa-exclamation';

export const ValidationMessageTypes = {
    ERROR: "error",
    WARNING: "warning"
};
